import React from 'react'

interface PdfViewerProps {
  src: string
  width?: string
  height?: string
}

const PdfViewer: React.FC<PdfViewerProps> = ({ src, width = '100%', height = '100%' }) => {
  return <iframe src={src} title="PDF viewer" width={width} height={height} style={{ border: 'none' }} />
}

export default PdfViewer
